export const getAudioParsingStatus = (state) => state.audio.parsingStatus;
export const getAudioAnalysisStatus = (state) => state.audio.analysisStatus;
export const getAudioPlayer = (state) => state.audio.player;
//export const getAudioFile = (state) => state.audio.audioFile;
export const getAudioResults = (state) => state.audio.results;
export const getAudioProgress = (state) => state.audio.progress;
export const getAudioRequestId = (state) => state.audio.requestId;
export const getAudioModels = (state) => state.audio.models;
export const getAudioFilter = (state) => state.audio.filter;
export const getAudioSummary = (state) => state.audio.summary;